/* eslint-disable @typescript-eslint/default-param-last */
import { Reducer } from 'redux';
import { Payouts } from 'store/Collections/Payouts';
import { IStatsState } from 'store/types';
import { Stats } from './types';

const initialState: IStatsState | null = null;

export const statsReducer: Reducer<IStatsState | null> = (state = initialState, action) => {
  switch (action.type) {
    case Stats.GET_SITE_PAYOUT_STATS_REQUEST:
    case Stats.GET_EMPLOYEE_PAYOUT_STATS_REQUEST:
    case Stats.GET_USER_PAYOUT_STATS_REQUEST: {
      return {
        ...state,
        payouts: null,
      };
    }
    case Stats.GET_SITE_PAYOUT_STATS_SUCCESS:
    case Stats.GET_EMPLOYEE_PAYOUT_STATS_SUCCESS:
    case Stats.GET_USER_PAYOUT_STATS_SUCCESS: {
      return {
        ...state,
        payouts: action.payload,
      };
    }
    case Stats.GET_TIP_ACCEPTANCE_PAYMENT_STATS_SUCCESS: {
      return {
        ...state,
        tipAcceptance: action.payload,
      };
    }
    case Stats.GET_TIP_ACCEPTANCE_PAYMENTS_PENDING_COUNT_SUCCESS: {
      return {
        ...state,
        counts: {
          ...state?.counts,
          tipAcceptancePendingPayments: action.payload.total,
        },
      };
    }
    case Stats.GET_TIP_ACCEPTANCE_PAYMENTS_PENDING_COUNT_REQUEST: {
      return {
        ...state,
        counts: {
          ...state?.counts,
          tipAcceptancePendingPayments: null,
        },
      };
    }
    case Payouts.GET_SITE_REVIEW_PAYOUTS_COUNT_REQUEST: {
      return {
        ...state,
        counts: {
          ...state?.counts,
          reviewPayouts: null,
        },
      };
    }
    case Payouts.GET_SITE_REVIEW_PAYOUTS_COUNT_SUCCESS:
    case Payouts.GET_SITE_REVIEW_PAYOUTS_SUCCESS: {
      const { total } = action.payload;
      return {
        ...state,
        counts: {
          ...state?.counts,
          reviewPayouts: total,
        },
      };
    }
    default: {
      return state;
    }
  }
};
